import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import { RTLProvider } from "@/components/RTLProvider";
import App from "./App.tsx";
import "./index.css";

// Initialize i18n before rendering
import "@/i18n";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
    <CurrencyProvider>
      <LanguageProvider>
        <SubscriptionProvider>
          <RTLProvider>
            <App />
          </RTLProvider>
        </SubscriptionProvider>
      </LanguageProvider>
    </CurrencyProvider>
  </ThemeProvider>
);
